import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { FloorManagementService } from 'src/app/floor-management/floor-management.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { CommonService } from 'src/app/shared/utils/common.service';
import {
  IDeviceType,
  IDeviceTypes,
  IDoorType,
} from '../../building-unit-details/device-management/device-management.interfaces';
import { DeviceSettingsService } from '../device-settings.service';
import { DeviceModeRequest } from 'src/app/shared/constants/request-mapping';
import { Subscription } from 'rxjs';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-change-door-mode',
  templateUrl: './change-door-mode.component.html',
  styleUrls: ['./change-door-mode.component.scss'],
})
export class ChangeDoorModeComponent implements OnInit, OnDestroy {
  /**
   * all necessary input get values from parent
   */
  @Input() formGroupName!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  readonly LANG_CONST = LANG_CONST;
  errorMessage: string = '';
  formGroup!: FormGroup;
  radionButtons: IDeviceTypes | undefined;
  existingType: string = '';
  doorDeviceId: string = '';
  accessPointId: string = '';
  subscription: Subscription | undefined;
  sharedData!: ISharedData;

  get formInstance() {
    return this.formGroup?.controls;
  }

  constructor(
    private rootFormGroup: FormGroupDirective,
    private deviceSettingservice: DeviceSettingsService,
    private notificationService: NotificationService,
    private floorManagementService: FloorManagementService,
    private commonService: CommonService,
    private sharedDataService: SharedDataService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {}

  /**
   * @description this is onInit life cycle method
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    // radio button list manage for active status
    this.radionButtons = [
      {
        label: this.translate.instant('LOCK_TEXT'),
        value: DeviceModeRequest[CONSTANTS.STATIC_STATE_LOCKED],
        active: false,
      },
      {
        label: this.translate.instant('UNLOCK_TEXT'),
        value: DeviceModeRequest[CONSTANTS.STATIC_STATE_UNLOCKED],
        active: false,
      },
    ];
    this.accessPointId = this.formInstance?.accessPointId?.value;
    this.radionButtons.map((deviceMode: IDoorType) => {
      if (deviceMode.value === this.formInstance?.deviceMode.value) {
        deviceMode.active = true;
      }
    });
    this.existingType = this.formInstance?.deviceMode?.value;
    this.floorManagementService
      .getPartnerDevicesByAccessPoint(this.accessPointId)
      .subscribe((res: any) => {
        let index = res.findIndex(
          (x: { deviceType: string }) => x.deviceType === 'Door'
        );
        this.doorDeviceId = res[index].deviceId;
      });

    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
      }
    );
  }

  /**
   * @description current selected group index mark as active status
   * @param userGroup active number
   */
  activate(deviceMode: IDoorType): void {
    this.radionButtons?.map((option: any) => (option.active = false));
    deviceMode.active = true;
  }

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper = 1));
    this.formInstance?.deviceMode.patchValue(this.existingType);
  }

  /**
   * @description #changeDeviceType function will update the device type by calling
   *               updatePartnerDeviceType API.
   * @returns void
   */

  changeDeviceType(): void {
    this.deviceSettingservice
      .updateDeviceMode(this.doorDeviceId, this.formInstance.deviceMode.value)
      .subscribe({
        next: (res: any) => {
          if (res && res?.updateDeviceMode?.deviceId) {
            //Test success message
            this.stepperChange.emit((this.stepper = 1));
            this.notificationService.showSuccess(
              this.commonService.stringInterPolation(
                this.translate.instant('UPDATED_SUCCESSFULLY'),
                this.translate.instant('DEVICE')
              )
            );

            // refresh event lock activity after update device mode
            const filterCriteriaEventHistory = {
              siteId: '',
            };
            filterCriteriaEventHistory.siteId = <string>(
              this.sharedData?.selectedSite?.siteId
            );
            this.floorManagementService
              .getEventHistoryByAccessPoint(
                <string>this.sharedData.selectedAccessPoint.accessPointId,
                filterCriteriaEventHistory
              )
              .subscribe();
          }
        },
        error: (err: Error) => {
          if (window.__dev__) console.log('updateDevice', err);
          this.notificationService.showError(err?.message);
        },
      });
  }

  /**
   * @description: runs just before component unmount. Unsubscribes the  service
   * @input {none}
   * @output {void}
   */
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
